import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: grid;
    grid-template-columns: max-content min-content;
    grid-column-gap: 0.3rem;
    grid-template-rows: auto auto;
    /* align-items: center; */
    font-size: 0.7rem;
    font-family: Inconsolata, Menlo, Consolas, monospace;
`

const Text = styled.div`
    max-width: 10rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2; 
    -webkit-box-orient: vertical;
`

const ClientTooltip = props => {
    const {
        account,
        source
    } = props

    return (
        <Container>
            <Text>Account:</Text>
            <Text>{account}</Text>
            <Text>Source:</Text>
            <Text>{source}</Text>
        </Container>
    )
}

export default ClientTooltip

